<template lang="pug">
.admin-actions
  .field
    label Sichtbarkeit setzen:
    select(v-model="localVisibility", @change="setvis")
      option(value="") Nicht ändern
      option(value="1") Gesperrt
      option(value="2") Privat
      option(value="3") Freunde
      option(value="4") Öffentlich

  .field
    label Tags setzen/löschen
    media-tags(mode="admin", @change="updateTags")

  .buttons
    button3d(@click="update") 
      icon.small(name="save")
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import Checker from "@/components/Checker.vue";
import Icon from "@/components/Icon.vue";
import Button3d from "./Button3d.vue";
import MediaTags from "./MediaTags.vue";

export default {
  name: "AdminActions",
  components: { Checker, Icon, Button3d, MediaTags },
  props: {
    visibility: Number,
    selectedIds: Set,
  },
  data() {
    return {
      tagStates: {},
      localTags: [],
      localVisibility: this.visibility,
    };
  },
  watch: {
    visibility(val) {
      this.localVisibility = val;
    },
  },
  async mounted() {
    // await this.getTags();
    // for (const tag of this.tags) {
    //   if (!(tag.id in this.tagStates)) {
    //     this.$set(this.tagStates, tag.id, 0); // Vue2 braucht $set, Vue3 nicht
    //   }
    // }
  },
  computed: {
    ...mapGetters({
      // tags: "media/tags",
      filter: "media/filter",
    }),
  },
  methods: {
    ...mapActions({
      // getTags: "media/tags",
    }),
    tagsChanged(data) {
      console.log(data);
    },
    setvis() {
      this.$emit("update:visibility", 1 * this.localVisibility);
    },
    updateTags(states) {
      console.log("states", states);
      this.tagStates = states;
    },
    update() {
      this.$emit("update:visibility", 1 * this.localVisibility);
      this.$emit("tagStates", this.tagStates);
      this.$emit("batchUpdate");
    },
  },
};
</script>

<style lang="less" scoped>
.admin-actions {
  margin-top: 2em;
  border-top: 1px solid #ccc;
  padding-top: 1em;

  .field {
    margin-bottom: 1em;
  }
}
.buttons {
  display: flex;
  .button {
    margin: 0 1vw;
  }
}
</style>
